"use client";

import { Link } from "react-router-dom";
import { useLanguage } from "@/i18n/LanguageContext";

export default function RelatedArticles() {
  const { t, currentLang } = useLanguage();
  const isEs = currentLang === "es";
  const blogPrefix = isEs ? "/es/blog/" : "/blog/";

  const articles = [
    {
      titleKey: "blog.articleInsurance.title",
      excerptKey: "blog.articleInsurance.excerpt",
      tagKey: "blog.catInsurance",
      to: `${blogPrefix}insurance-discount-impact-windows/`,
    },
    {
      titleKey: "blog.articleCost.title",
      excerptKey: "blog.articleCost.excerpt",
      tagKey: "blog.catPricing",
      to: `${blogPrefix}window-repair-cost-miami/`,
    },
    {
      titleKey: "blog.articleCodes.title",
      excerptKey: "blog.articleCodes.excerpt",
      tagKey: "blog.catCodes",
      to: `${blogPrefix}hvhz-code-noa-explained/`,
    },
  ];

  return (
    <section className="py-12">
      <h2 className="text-2xl font-bold text-[#064e3b] mb-6">{t("blog.shutters.relatedHeading")}</h2>
      <div className="grid grid-cols-1 sm:grid-cols-3 gap-6">
        {articles.map((a) => (
          <Link
            key={a.to}
            to={a.to}
            className="bg-white rounded-lg border border-[#064e3b]/10 p-5 hover:shadow-lg hover:border-[#fbbf24]/50 transition block"
          >
            <span className="inline-block bg-[#fbbf24] text-[#064e3b] text-xs uppercase tracking-widest px-3 py-1 rounded">
              {t(a.tagKey)}
            </span>
            <h3 className="font-bold text-[#064e3b] mt-3 text-lg leading-snug">{t(a.titleKey)}</h3>
            <p className="text-sm text-gray-600 mt-2 leading-relaxed">{t(a.excerptKey)}</p>
            <span className="inline-block mt-4 text-[#047857] text-sm font-medium hover:text-[#ea580c]">
              {t("blog.shutters.readFull")}
            </span>
          </Link>
        ))}
      </div>
    </section>
  );
}